import React, { useEffect, useState } from 'react'
import './ChatMessage.sass'
import { Hint, Topic } from '../../types/data'

export enum HintItemType {
    topic = 'topic',
    hint = 'hint',
}

interface Props {
    item: Hint | Topic
    type: HintItemType
    index: number
    onSelect: (item: Hint | Topic) => void
}

const HintBubble: React.FC<Props> = (props) => {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        setTimeout(() => {
            setIsVisible(true)
        }, (props.index + 1) * 200)
    }, [])

    return (
        <button
            className={`hint-bubble ${isVisible ? 'hint-bubble-visible' : 'hint-bubble-not-visible'}`}
            onClick={() => props.onSelect(props.item)}
        >
            {props.item.title}
        </button>
    )
}

export default HintBubble
